exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.filter-grid .k-grid {\n  max-height: 400px;\n}\n\ndiv.filter-grid .k-grid td {\n  padding: 5px;\n}\n\ndiv.filter-grid .switch {\n  height: 17px;\n  width: 43px;\n}\ndiv.filter-grid .slider.round {\n  border-radius: 34px;\n}\ndiv.filter-grid .slider:before {\n  height: 13px;\n  width: 13px;\n  left: 2px;\n  bottom: 2px;\n}\n\n.rasa-hidden-field {\n  display: none !important;\n}\n\n.page-header-container{\n  text-align: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/source-config/filters/styles.css
// module id = 2607
// module chunks = 29